export default "__VITE_ASSET__BHUegNa$__"